import Types from '../constants/actionTypes';

const toggleTrash = () => dispatch => dispatch({ type: Types.TOGGLE_TRASH });

export default toggleTrash;
